import React from "react";
import { Label } from "../InputField1/InputFiled1Style";
import { SimpleTextAreaStyle } from "./SimpleTextAreaStyle";

export const SimpleTextArea = ({
  label,
  placeholder,
  name,
  id,
  cols,
  rows,
  onChange,
  value,
}) => {
  return (
    <SimpleTextAreaStyle>
      {label ? <Label>{label}</Label> : null}
      <textarea
        className="form-control"
        placeholder={placeholder}
        name={name}
        id={id}
        cols={cols}
        rows={rows}
        onChange={onChange}
        value={value}
      ></textarea>
    </SimpleTextAreaStyle>
  );
};
